function n(t) {
  var e;
  const r = (e = t.card) == null ? void 0 : e.country;
  return {
    stripePaymentMethodId: t.id,
    ...r ? { cardIssueCountry: r } : {}
  };
}
export {
  n as getStripeCardRequestOptions
};
